import IconLink from "../common/IconLink";
import { useTranslation } from '../../i18n/LanguageProvider';

// A reusable component for rendering a single publication
function PublicationItem({ href, title, tooltip }) {
  return (
    <li>
      <a href={href}>{title}</a>
      {tooltip && (
        <IconLink label={tooltip}>
          <i className="mb--1 icon-open-access"></i>
        </IconLink>
      )}
    </li>
  );
}

export default function SelectedPublications() {
  const { t } = useTranslation();
  const publications = [
    {
      href: '/publications/2022-sensors',
      title: 'Self-Sovereign Identity: A Systematic Review, Mapping and Taxonomy',
      // tooltip: 'Open Access',
    },
    {
      href: '/publications/2024-sac',
      title:
        'From Self-Sovereign Identity to Fiduciary Identity: A Journey Towards Greater User Privacy and Usability',
    },
    {
      href: '/publications/2024-er',
      title: 'The Role-Artifact-Function Framework for Understanding Digital Identity Models',
    },
  ];

  return (
    <div id="publications" className="card mb-4">
      <div className="card-body">
        <h2 className="card-title">{t('home.selectedPublications')}</h2>
        <ul className="mb-0">
          {publications.map((pub, index) => (
            <PublicationItem
              key={index}
              href={pub.href}
              title={pub.title}
              tooltip={pub.tooltip}
            />
          ))}
        </ul>
      </div>
    </div>
  );
}
